import { useCallback, useState } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';
import type { Editor } from '#src/app/shared/components/richTextEditor';

type UseDescriptionReturn = ModelHookResult<
	{
		value: string;
		error: string | null;
	},
	{
		handleChange: (editorText: string, editor: Editor) => void;
	}
>;

export function useDescription(): UseDescriptionReturn {
	const { typedTranslate } = useI18n();
	const [state, mutations] = usePetitionEditPageState();
	const [initialDescription] = useState(state.formState.description.value || '');

	const handleChange = useCallback(
		(editorText: string, editor: Editor) => {
			if (state.formState.description.error) {
				mutations.resetFieldError('description');
			}
			mutations.setDescription({ value: editorText, isDirty: editor.isDirty() });
		},
		[mutations, state.formState.description.error],
	);
	return {
		data: {
			value: initialDescription,
			error: state.formState.description.error !== null ? typedTranslate(state.formState.description.error) : null,
		},
		actions: {
			handleChange,
		},
	};
}
